import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DriversEventCalendar from '../drivers-event-calendar.jsx';


if (document.getElementById('react-component-g4-logistics-portal-drivers-event-calendar')) {
  ReactDOM.render(
    <DriversEventCalendar
      url="/api/v1/portal/drivers/event/get-drivers-calendar"
      isLoading={true}
    />,
    document.getElementById('react-component-g4-logistics-portal-drivers-event-calendar'));
}
